import lodash from 'lodash'
export default {
  setData (state, payload) {
    state.users = payload.data
    state.current_page = payload.meta ? payload.meta.current_page : 1
    state.last_page = payload.meta ? payload.meta.last_page : 1
    state.per_page = payload.meta ? payload.meta.per_page : 1
    state.total = payload.meta ? payload.meta.total : 1
  },

  setOrganization (state, payload) {
    state.organizations = payload.data
  },

  destroyUser (state, payload) {
    var index = lodash.findIndex(state.users, ['id', payload.id])
    state.users.splice(index, 1)
    state.total -= 1
  },

  getTrashUser (state, payload) {
    state.trash.users = payload.data
    state.trash.last_page = payload.meta.last_page
    state.trash.total = payload.meta.total
  },

  restore (state, payload) {
    state.trash.result = payload
  },

  updateUser (state, payload) {
    var index = lodash.findIndex(state.users, ['id', payload.id])
    state.users.splice(index, 1, payload)
  },

  getUserOnline (state, payload) {
    state.user_online = payload
  }

}



// WEBPACK FOOTER //
// ./src/store/module/user/mutations.js